/*==================================================
=                 GRAFIK KESEHATAN
==================================================*/

/*
  Grafik bersama untuk BMI anak usia 5–19 tahun.
  Slider usia 0–5 tahun menggunakan grafik terpisah.
*/

let whoChart = null;

let currentGrowthChartData = null;

const growthSlideCharts = {};


/*==================================================
=          PEMBANTU KURVA WHO BERSAMA
==================================================*/

function createWHOCurveData(
    data,
    gender
) {

    if (
        !data ||
        !gender ||
        !data[gender]
    ) {
        return null;
    }

    const curves = {
        minus3: [],
        minus2: [],
        minus1: [],
        median: [],
        plus1: [],
        plus2: [],
        plus3: []
    };

    const keys =
        Object.keys(data[gender])
            .map(Number)
            .filter(Number.isFinite)
            .sort(function (a, b) {
                return a - b;
            });

    keys.forEach(function (key) {

        let ref =
            data[gender][key];

        if (!ref) {

            ref =
                data[gender][
                    key.toFixed(1)
                ];

        }

        if (!ref) {
            return;
        }

        const L =
            Number(ref.L);

        const M =
            Number(ref.M);

        const S =
            Number(ref.S);

        if (
            !Number.isFinite(L) ||
            !Number.isFinite(M) ||
            !Number.isFinite(S)
        ) {
            return;
        }

        function valueAtZ(z) {

            if (L === 0) {

                return (
                    M *
                    Math.exp(S * z)
                );

            }

            const base =
                1 + L * S * z;

            if (base <= 0) {
                return null;
            }

            return (
                M *
                Math.pow(
                    base,
                    1 / L
                )
            );

        }

        const curveDefinitions = [
            ["minus3", -3],
            ["minus2", -2],
            ["minus1", -1],
            ["median", 0],
            ["plus1", 1],
            ["plus2", 2],
            ["plus3", 3]
        ];

        curveDefinitions.forEach(
            function (definition) {

                const curveName =
                    definition[0];

                const z =
                    definition[1];

                const value =
                    valueAtZ(z);

                if (
                    value !== null &&
                    Number.isFinite(value)
                ) {

                    curves[curveName].push({
                        x: key,
                        y: value
                    });

                }

            }
        );

    });

    return curves;

}


function buildWHOLineDatasets(curves) {

    if (!curves) {
        return [];
    }

    return [
        {
            label: "-3 SD",
            data: curves.minus3,
            borderColor: "#d32f2f",
            borderWidth: 1,
            pointRadius: 0,
            pointHoverRadius: 0,
            fill: false,
            tension: 0.2
        },
        {
            label: "-2 SD",
            data: curves.minus2,
            borderColor: "#f57c00",
            borderWidth: 1,
            pointRadius: 0,
            pointHoverRadius: 0,
            fill: false,
            tension: 0.2
        },
        {
            label: "-1 SD",
            data: curves.minus1,
            borderColor: "#fbc02d",
            borderWidth: 1,
            pointRadius: 0,
            pointHoverRadius: 0,
            fill: false,
            tension: 0.2
        },
        {
            label: "Median",
            data: curves.median,
            borderColor: "#2e7d32",
            borderWidth: 2.5,
            pointRadius: 0,
            pointHoverRadius: 0,
            fill: false,
            tension: 0.2
        },
        {
            label: "+1 SD",
            data: curves.plus1,
            borderColor: "#fbc02d",
            borderWidth: 1,
            pointRadius: 0,
            pointHoverRadius: 0,
            fill: false,
            tension: 0.2
        },
        {
            label: "+2 SD",
            data: curves.plus2,
            borderColor: "#f57c00",
            borderWidth: 1,
            pointRadius: 0,
            pointHoverRadius: 0,
            fill: false,
            tension: 0.2
        },
        {
            label: "+3 SD",
            data: curves.plus3,
            borderColor: "#d32f2f",
            borderWidth: 1,
            pointRadius: 0,
            pointHoverRadius: 0,
            fill: false,
            tension: 0.2
        }
    ];

}


function createPatientDataset(
    patientPoint
) {

    return {
        label: "Hasil Anak Anda",
        type: "scatter",
        data: [patientPoint],
        pointRadius: 6,
        pointHoverRadius: 8,
        pointBackgroundColor: "#000000",
        pointBorderColor: "#ffffff",
        pointBorderWidth: 2,
        showLine: false
    };

}


function createWHOChartOptions(
    xLabel,
    yLabel
) {

    return {
        responsive: true,
        maintainAspectRatio: false,

        animation: {
            duration: 250
        },

        layout: {
            padding: {
                top: 8,
                right: 14,
                bottom: 8,
                left: 6
            }
        },

        interaction: {
            mode: "nearest",
            intersect: false
        },

        plugins: {
            legend: {
                position: "bottom",

                labels: {
                    boxWidth: 11,
                    boxHeight: 2,
                    padding: 8,

                    font: {
                        size: 9
                    }
                }
            },

            tooltip: {
                callbacks: {
                    label: function (context) {

                        const label =
                            context.dataset.label ||
                            "";

                        const x =
                            Number(
                                context.parsed.x
                            ).toFixed(1);

                        const y =
                            Number(
                                context.parsed.y
                            ).toFixed(2);

                        return (
                            `${label}: ` +
                            `x ${x}, y ${y}`
                        );

                    }
                }
            }
        },

        scales: {
            x: {
                type: "linear",

                title: {
                    display: true,
                    text: xLabel,

                    font: {
                        size: 11
                    }
                },

                ticks: {
                    maxTicksLimit: 7,

                    font: {
                        size: 9
                    }
                },

                grid: {
                    color:
                        "rgba(0, 0, 0, 0.06)"
                }
            },

            y: {
                grace: "8%",

                title: {
                    display: true,
                    text: yLabel,

                    font: {
                        size: 11
                    }
                },

                ticks: {
                    maxTicksLimit: 7,

                    font: {
                        size: 9
                    }
                },

                grid: {
                    color:
                        "rgba(0, 0, 0, 0.06)"
                }
            }
        }
    };

}


/*==================================================
=          GRAFIK BMI ANAK USIA 5–19 TAHUN
==================================================*/

function drawChildBMIChart(
    result,
    sex,
    bmi519Data
) {

    if (
        !result ||
        !bmi519Data
    ) {
        return;
    }

    const gender =
        sex === "male"
            ? "boys"
            : "girls";

    const curves =
        createWHOCurveData(
            bmi519Data,
            gender
        );

    if (!curves) {

        console.error(
            "Kurva BMI WHO usia 5–19 tahun tidak dapat dibuat."
        );

        return;

    }

    const canvas =
        document.getElementById(
            "whoChart"
        );

    if (
        !canvas ||
        typeof Chart === "undefined"
    ) {
        return;
    }

    if (whoChart) {

        whoChart.destroy();
        whoChart = null;

    }

    const datasets =
        buildWHOLineDatasets(
            curves
        );

    datasets.push(
        createPatientDataset({
            x: result.month,
            y: result.bmi
        })
    );

    const titleElement =
        document.getElementById(
            "who-chart-title"
        );

    if (titleElement) {

        titleElement.textContent =
            "Grafik BMI Menurut Usia WHO";

    }

    whoChart =
        new Chart(
            canvas.getContext("2d"),
            {
                type: "line",

                data: {
                    datasets: datasets
                },

                options:
                    createWHOChartOptions(
                        "Usia (bulan)",
                        "BMI"
                    )
            }
        );

}


function drawChildChart(
    result,
    sex,
    bmi519Data
) {

    drawChildBMIChart(
        result,
        sex,
        bmi519Data
    );

}


/*==================================================
=          DATA GRAFIK PERTUMBUHAN 0–5
==================================================*/

function setGrowthChartData(config) {

    currentGrowthChartData =
        config;

}


function destroyGrowthSlideCharts() {

    Object.keys(
        growthSlideCharts
    ).forEach(function (chartType) {

        const chart =
            growthSlideCharts[
                chartType
            ];

        if (chart) {
            chart.destroy();
        }

        delete growthSlideCharts[
            chartType
        ];

    });

}


/*==================================================
=          GRAFIK SLIDER PERTUMBUHAN 0–5
==================================================*/

function drawGrowthSlideChart(
    chartType
) {

    if (
        !currentGrowthChartData ||
        typeof Chart === "undefined"
    ) {
        return;
    }

    const canvas =
        document.getElementById(
            `growth-chart-${chartType}`
        );

    if (!canvas) {
        return;
    }

    if (
        growthSlideCharts[
            chartType
        ]
    ) {

        growthSlideCharts[
            chartType
        ].destroy();

        delete growthSlideCharts[
            chartType
        ];

    }

    const config =
        currentGrowthChartData;

    const gender =
        config.sex === "male"
            ? "boys"
            : "girls";

    let dataset = null;
    let patientPoint = null;
    let xLabel = "";
    let yLabel = "";

    if (chartType === "height") {

        dataset =
            config.datasets.height;

        patientPoint = {
            x: config.ageMonths,
            y: config.height
        };

        xLabel =
            "Usia (bulan)";

        yLabel =
            "Panjang / Tinggi Badan (cm)";

    } else if (
        chartType === "weight"
    ) {

        dataset =
            config.datasets.weight;

        patientPoint = {
            x: config.ageMonths,
            y: config.weight
        };

        xLabel =
            "Usia (bulan)";

        yLabel =
            "Berat Badan (kg)";

    } else if (
        chartType === "head"
    ) {

        if (
            !config.head ||
            config.head <= 0
        ) {
            return;
        }

        dataset =
            config.datasets.head;

        patientPoint = {
            x: config.ageMonths,
            y: config.head
        };

        xLabel =
            "Usia (bulan)";

        yLabel =
            "Lingkar Kepala (cm)";

    } else if (
        chartType === "proportion"
    ) {

        const useLength =
            config.ageMonths < 24;

        dataset =
            useLength
                ? config.datasets
                    .weightLength
                : config.datasets
                    .weightHeight;

        patientPoint = {
            x:
                Math.round(
                    config.height * 2
                ) / 2,

            y: config.weight
        };

        xLabel =
            useLength
                ? "Panjang Badan (cm)"
                : "Tinggi Badan (cm)";

        yLabel =
            "Berat Badan (kg)";

    }

    if (!dataset) {

        console.error(
            `Dataset WHO tidak tersedia untuk grafik: ${chartType}`
        );

        return;

    }

    const curves =
        createWHOCurveData(
            dataset,
            gender
        );

    if (!curves) {

        console.error(
            `Kurva WHO tidak dapat dibuat untuk grafik: ${chartType}`
        );

        return;

    }

    const datasets =
        buildWHOLineDatasets(
            curves
        );

    datasets.push(
        createPatientDataset(
            patientPoint
        )
    );

    window.requestAnimationFrame(
        function () {

            growthSlideCharts[
                chartType
            ] = new Chart(
                canvas.getContext(
                    "2d"
                ),
                {
                    type: "line",

                    data: {
                        datasets: datasets
                    },

                    options:
                        createWHOChartOptions(
                            xLabel,
                            yLabel
                        )
                }
            );

            window.setTimeout(
                function () {

                    const chart =
                        growthSlideCharts[
                            chartType
                        ];

                    if (chart) {
                        chart.resize();
                    }

                },
                50
            );

        }
    );

}